import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { QRScanner } from '@awesome-cordova-plugins/qr-scanner/ngx';

import { ScanQrcodeComponent } from './scan-qrcode.component';
import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';
import { InboxComponentsModule } from 'src/app/components/inbox/inbox.components.module';

@NgModule({
    declarations: [
      ScanQrcodeComponent
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        OfflineComponentsModule,
        InboxComponentsModule,
    ],
    exports: [
        ScanQrcodeComponent
    ],
    providers: [
        // QRScanner
    ],
})
export class ScanQrcodeComponentsModule { }
